// Used to set the tab index of an element based on a boolean value.
// Return `-1` if not tabbable, otherwise `0`.
export const setTabIndex = (isTabbable) => (isTabbable ? 0 : -1);

export const buildRatingOptionArialLabel = (translation, options, index, position, minLabel, maxLabel) => {
  let ariaLabel = `${translation.clickSelect} ${position}`;
  if (index === 0 && minLabel) {
    ariaLabel += `, ${position} ${translation.means} ${minLabel}`;
  } else if (index === options.length - 1 && maxLabel) {
    ariaLabel += `, ${position} ${translation.means} ${maxLabel}`;
  }
  return ariaLabel;
};
